import { useQuery } from '@tanstack/react-query';
import { BENE_REMOTE_ID_KEY } from '../../utils/constants/queryKeys';
import { getRemoteBeneficiaryId } from '../services/fn-api/Beneficiary';

export const useGetRemoteBeneficiaryId = (beneId: number) => {
  return useQuery({
    queryKey: [BENE_REMOTE_ID_KEY, beneId],
    queryFn: () => getRemoteBeneficiaryId(beneId),
    enabled: beneId > 0,
  });
};
